/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsGetCoverage } from "../funcs/deviceIntegrationsGetCoverage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DeviceIntegrationCoverage } from "../models/components/deviceintegrationcoverage.js";
import {
  GetDeviceIntegrationCoverageRequest,
  GetDeviceIntegrationCoverageSecurity,
} from "../models/operations/getdeviceintegrationcoverage.js";
import { unwrapAsync } from "../types/fp.js";
export type DeviceIntegrationCoverageQueryData = DeviceIntegrationCoverage;

export function prefetchDeviceIntegrationCoverage(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetDeviceIntegrationCoverageRequest | undefined,
  security?: GetDeviceIntegrationCoverageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeviceIntegrationCoverageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeviceIntegrationCoverageQuery(
  client$: GramCore,
  request?: GetDeviceIntegrationCoverageRequest | undefined,
  security?: GetDeviceIntegrationCoverageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DeviceIntegrationCoverageQueryData>;
} {
  return {
    queryKey: queryKeyDeviceIntegrationCoverage({
      provider: request?.provider,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function deviceIntegrationCoverageQueryFn(
      ctx,
    ): Promise<DeviceIntegrationCoverageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsGetCoverage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeviceIntegrationCoverage(
  parameters: {
    provider?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deviceIntegrations", "getCoverage", parameters];
}
